export const MODEL_COLUMN_PREFERENCES = [
  {
    key: 1,
    label: "Model Holding (default)",
    type: "name",
    visible: true,
  },
  {
    key: 2,
    label: "Ticker",
    type: "ticker",
    visible: true,
  },
  {
    key: 3,
    label: "Return",
    type: "return",
    visible: false,
  },
  {
    key: 4,
    label: "Category",
    type: "category",
    visible: true,
  },
  {
    key: 5,
    label: "Allocation %",
    type: "weight",
    visible: true,
  },
];

export const MODEL_INVESTMENT_AMOUNT = 100000;
